// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* ALERT COMPONENT STYLES - VANTA INSPIRED     */
/* ============================================= */

.alert {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-radius: 0.75rem;
  border-left: 4px solid transparent;
  animation: slideInDown 300ms ease-out;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-icon {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.alert-content {
  flex: 1 1;
}

.alert-close {
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 1rem;
  padding: 0;
  transition: all 200ms ease-in-out;
}

.alert-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.dark .alert-close:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Alert Title */
.alert-title {
  margin: 0 0 0.25rem 0;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.4;
}

/* Alert Description */
.alert-description {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
}

/* Alert Variants - Info */
.alert-info {
  background-color: #F0F9FF;
  color: #0C4A6E;
  border-left-color: #0EA5E9;
}

.dark .alert-info {
  background-color: rgba(14, 165, 233, 0.1);
  color: #38BDF8;
  border-left-color: #0EA5E9;
}

/* Alert Variants - Success */
.alert-success {
  background-color: #ECFDF5;
  color: #065F46;
  border-left-color: #22C55E;
}

.dark .alert-success {
  background-color: rgba(34, 197, 94, 0.1);
  color: #4ADE80;
  border-left-color: #22C55E;
}

/* Alert Variants - Warning */
.alert-warning {
  background-color: #FFFBEB;
  color: #92400E;
  border-left-color: #F59E0B;
}

.dark .alert-warning {
  background-color: rgba(245, 158, 11, 0.1);
  color: #FBBF24;
  border-left-color: #F59E0B;
}

/* Alert Variants - Error */
.alert-error {
  background-color: #FFF5F7;
  color: #9F1239;
  border-left-color: #EC4899;
}

.dark .alert-error {
  background-color: rgba(236, 72, 153, 0.1);
  color: #F472B6;
  border-left-color: #EC4899;
}

/* Alert Outline Variant */
.alert-outline {
  border: 1px solid currentColor;
  border-left-width: 4px;
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Alert.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,gDAAgD;AAChD,kDAAkD;;AAElD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;AAC/B","sourcesContent":["/* ============================================= */\n/* ALERT COMPONENT STYLES - VANTA INSPIRED     */\n/* ============================================= */\n\n.alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border-radius: 0.75rem;\n  border-left: 4px solid transparent;\n  animation: slideInDown 300ms ease-out;\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.alert-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n.alert-content {\n  flex: 1;\n}\n\n.alert-close {\n  flex-shrink: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 1.5rem;\n  height: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.375rem;\n  font-size: 1rem;\n  padding: 0;\n  transition: all 200ms ease-in-out;\n}\n\n.alert-close:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.dark .alert-close:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Alert Title */\n.alert-title {\n  margin: 0 0 0.25rem 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n/* Alert Description */\n.alert-description {\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n/* Alert Variants - Info */\n.alert-info {\n  background-color: #F0F9FF;\n  color: #0C4A6E;\n  border-left-color: #0EA5E9;\n}\n\n.dark .alert-info {\n  background-color: rgba(14, 165, 233, 0.1);\n  color: #38BDF8;\n  border-left-color: #0EA5E9;\n}\n\n/* Alert Variants - Success */\n.alert-success {\n  background-color: #ECFDF5;\n  color: #065F46;\n  border-left-color: #22C55E;\n}\n\n.dark .alert-success {\n  background-color: rgba(34, 197, 94, 0.1);\n  color: #4ADE80;\n  border-left-color: #22C55E;\n}\n\n/* Alert Variants - Warning */\n.alert-warning {\n  background-color: #FFFBEB;\n  color: #92400E;\n  border-left-color: #F59E0B;\n}\n\n.dark .alert-warning {\n  background-color: rgba(245, 158, 11, 0.1);\n  color: #FBBF24;\n  border-left-color: #F59E0B;\n}\n\n/* Alert Variants - Error */\n.alert-error {\n  background-color: #FFF5F7;\n  color: #9F1239;\n  border-left-color: #EC4899;\n}\n\n.dark .alert-error {\n  background-color: rgba(236, 72, 153, 0.1);\n  color: #F472B6;\n  border-left-color: #EC4899;\n}\n\n/* Alert Outline Variant */\n.alert-outline {\n  border: 1px solid currentColor;\n  border-left-width: 4px;\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
